import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases, type Purchase } from '../data/purchases';
import { PRODUCT_NAME } from './constants';
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState<Purchase>(purchases[0]);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);
  if (!visible) return null;
  return <aside className="fixed bottom-3 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[260px] animate-slide-in" aria-live="polite" data-id="element-123" data-mp="165hcgvwws971">
      <div className="relative overflow-hidden rounded-xl border-2 border-golf-lime bg-white p-2.5 pr-7 shadow-2xl ring-2 ring-golf-gold/80" data-id="element-124" data-mp="116mges9xko4z">
        <div className="absolute inset-x-0 top-0 h-1 bg-golf-lime" data-id="element-125" data-mp="1awzc9gn743qf" />
        <button type="button" onClick={() => setVisible(false)} className="absolute right-1.5 top-1.5 rounded p-0.5 text-golf-muted transition-colors duration-150 ease-out hover:text-golf-green" aria-label="Close notification" data-id="element-126" data-mp="1ayshqsm2ohwu">
          <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-127" data-mp="x6vv3436b07u" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-128" data-mp="s56gjegqs4f0">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-golf-lime bg-golf-lime/20" data-id="element-129" data-mp="s8kk2q156jo1">
            <ShoppingBagIcon className="h-4 w-4 text-golf-green" aria-hidden="true" data-id="element-130" data-mp="23m6827v9mf7z" />
          </span>
          <div className="min-w-0 leading-tight" data-id="element-131" data-mp="2apcr8yu90zhe">
            <p className="font-head text-[13px] font-bold text-golf-green" data-id="element-132" data-mp="2aqnt2t44vx5v">{current.name}</p>
            <p className="text-[11px] font-semibold text-golf-muted" data-id="element-133" data-mp="2flthpzox7pxn">
              from {current.city}, {current.region}
            </p>
            <p className="mt-0.5 text-[11px] font-bold text-golf-lime" data-id="element-134" data-mp="2plkd03lb28ys">
              just purchased {PRODUCT_NAME}
            </p>
          </div>
        </div>
      </div>
    </aside>;
}